var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_2430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.00159073 4.16012C-0.00159073 9.25345 6.75174 16.0001 11.8384 16.0001C12.9517 16.0001 13.9917 15.5801 14.7584 14.8135L15.4251 14.0468C16.1984 13.2735 16.1984 11.9668 15.3917 11.1601C15.3717 11.1401 13.7651 9.90679 13.7651 9.90679C12.9651 9.14678 11.7051 9.14678 10.9117 9.90679L9.93841 10.6868C7.80508 9.78012 6.29174 8.26012 5.31841 6.05345L6.09174 5.08012C6.85841 4.28678 6.85841 3.02012 6.09174 2.22678C6.09174 2.22678 4.85841 0.620117 4.83841 0.600117C4.03174 -0.20655 2.72507 -0.20655 1.91841 0.600117L1.21841 1.20678C0.418408 2.00012 -0.00159073 3.04012 -0.00159073 4.15345V4.16012Z",
    fill: "#2182B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_2430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.43a120fb222d57580cb87b62d99fd5bb.svg";
export { ForwardRef as ReactComponent };